import { EVENT } from "../config";
import { Bed, Mail } from "lucide-react";

export const Accommodation = () => (
  <section
    className="px-6 py-16 md:px-16 md:py-24"
    data-testid="accommodation-section"
  >
    <div className="mx-auto max-w-4xl">
      <p className="mb-4 text-xs uppercase tracking-[0.3em] text-[#7A6A5E]">Accommodation</p>
      <h2 className="font-display text-3xl font-light tracking-tight text-[#3F3A32] md:text-5xl">
        Seglarhotellet
      </h2>

      <img
        src="/photos/seglarhotellet-day.jpg"
        alt="Seglarhotellet, Sandhamn"
        data-testid="accommodation-image"
        className="mt-16 h-[40vh] w-full object-cover md:h-[55vh]"
      />
      <div className="mt-5 border border-[#C9BFA9] bg-[#FAF7F0] p-10 md:p-14">
        <Bed className="h-6 w-6 text-[#7A6A5E]" strokeWidth={1.5} />
        <p className="mt-8 font-display text-2xl font-light tracking-tight text-[#3F3A32] md:text-3xl">
          {EVENT.accommodationPrice}
        </p>
        <p className="mt-2 text-lg font-light text-[#3F3A32]">
          {EVENT.accommodationCancel}
        </p>

        <ul className="mt-8 space-y-2">
          {EVENT.accommodationNotes.map((note) => (
            <li
              key={note}
              className="flex items-start gap-3 text-base font-light leading-relaxed text-[#5E574B]"
            >
              <span className="mt-[10px] h-1 w-1 shrink-0 rounded-full bg-[#7A6A5E]" />
              {note}
            </li>
          ))}
        </ul>

        <p className="mt-8 text-sm text-[#7A7264]">
          {EVENT.accommodationOptOut}{" "}
          <a
            href={`mailto:${EVENT.accommodationEmail}?subject=${encodeURIComponent(EVENT.accommodationRef)}`}
            data-testid="info-accommodation-link"
            className="inline-flex items-center gap-1.5 text-[#7A6A5E] underline decoration-[#C9BFA9] underline-offset-4 transition-colors hover:text-[#3F3A32]"
          >
            <Mail className="h-3.5 w-3.5" /> {EVENT.accommodationEmail}
          </a>
        </p>
      </div>
    </div>
  </section>
);
